import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { createPaginationLinks } from '@/helpers/pagination';
import Previous from './Previous';
import Next from './Next';
import styles from './Pagination.module.scss';

interface IPagination {
  pagesCount?: number;
  isStaticPages?: boolean;
  postName?: string;
  extraClassName?: string;
  postfixUrl?: string;
  defaultCurrentPage?: number;
}

const Pagination: FC<IPagination> = ({ pagesCount = 0, postName = 'rating', extraClassName, postfixUrl, isStaticPages = false, defaultCurrentPage }) => {
  const getClassName = () => (extraClassName ? `${styles.pagination} ${styles[`${extraClassName}`]}` : styles.pagination);

  if (!pagesCount || !postName) {
    return null;
  }

  const router = useRouter();

  let currentPageNo: number;

  //Проверка на статические страницы
  if (!!isStaticPages) {
    const staticPagePathSplit = router.pathname.split('/');
    currentPageNo = Number(staticPagePathSplit[staticPagePathSplit.length - 1]);
  } else {
    // Номер страницы для динамических страниц

    currentPageNo = defaultCurrentPage ? defaultCurrentPage : parseInt((router?.query?.pageNumber as any) ?? 1) || 1;
  }

  const paginationLinks = createPaginationLinks(currentPageNo, pagesCount);

  return (
    <>
      {pagesCount > 1 && (
        <div className={styles.bookPagination}>
          <div className={getClassName()}>
            <Previous currentPageNo={currentPageNo} postName={postName} />

            {paginationLinks.map((pageNo: number, index: number) => {
              const paginationLink = postfixUrl ? `/${postName}${pageNo}${postfixUrl}` : `/${postName}${pageNo}`;

              return 'number' === typeof pageNo ? (
                <Link
                  prefetch={false}
                  key={`id-${index}`}
                  href={pageNo === 1 ? `/${postName.split('pages')[0].split(`/${currentPageNo}`)[0].slice(0, -1)}` : paginationLink}
                  className={pageNo === currentPageNo ? `${styles.active}` : `${styles.pagination_link}`}
                >
                  {pageNo}
                </Link>
              ) : (
                <span className={styles.pagination_dots} key={`id-${index}`}>
                  {pageNo}
                </span>
              );
            })}

            <Next currentPageNo={currentPageNo} pagesCount={pagesCount} postName={postName} />
          </div>
        </div>
      )}
    </>
  );
};

export default Pagination;
